import { ds24_unique_id } from "../common/ds24_unique_id";
import { 
    ds24cart_isFullscreen,
    ds24cart_windowHeight, 
    ds24cart_windowScrollLeft, 
    ds24cart_windowScrollTop, 
    ds24cart_windowWidth 
} from "./ds24cart_helper";
import { setHtml } from "../browser/setHtml";
import { selectElement } from "../browser/selectElement";

export function ds24cart_tooltip_create( button_id: string, width: number, height: number )
{
    var div_id = ds24_unique_id();

    const button = document.getElementById(button_id);
    if (!button) {
        console.log(`button_id ${button_id} not found!`);
        return;
    }
    const buttonPosition = button.getBoundingClientRect();

    var top  = buttonPosition.y + ds24cart_windowScrollTop();
    var left = buttonPosition.x + ds24cart_windowScrollLeft();

    var padding_top = buttonPosition.height;

    var window_width = ds24cart_windowWidth();
    var is_full_screen = ds24cart_isFullscreen();

    if (width > window_width) width = window_width;

    var style_attr = is_full_screen
                   ? ''
                   : 'style="width: '+width+'px; height:'+height+'px;"';

    var inner_html = "<div class='app_cart_waiting' " + style_attr + "></div>";

    const old_div_id = button.getAttribute('ds24-tt-id');
    const old_div = document.getElementById(old_div_id as string);
    if (old_div)
    {
        old_div.parentNode?.removeChild(old_div);
    }

    button.setAttribute('ds24-tt-id', div_id );

    var extra_css = is_full_screen
                  ? 'ds24_tooltip_container_fullscreen'
                  : 'ds24_tooltip_container_window';

    const tooltip = document.createElement('div');
    tooltip.id = div_id;
    tooltip.className = 'app_cart_tooltip_container app_cart_closable ' + extra_css;
    
    let html = "<div class='app_cart_tooltip'>";
    html += inner_html;
    html += "</div>";
    setHtml(tooltip, html);

    if (is_full_screen) {
        document.body.insertBefore(tooltip, document.body.firstElementChild);
    }
    else
    {
        document.body.appendChild(tooltip);
    }

    if (is_full_screen)
    {
    }
    else
    {
        var vertical_pos: 'top'|'bottom'   = 'top';
        var horizontal_pos: 'left'|'right' = 'left';

        var win_w = ds24cart_windowWidth();
        var win_h = ds24cart_windowHeight();

        var is_bottom = top  + height > Math.round( 0.8 * win_h);
        var is_right  = left + width  > Math.round( 0.8 * win_w);

        if (is_bottom) { vertical_pos   = 'bottom'; top  = win_h - top ; }
        if (is_right)  { horizontal_pos = 'right';  left = win_w - left - buttonPosition.width; }

        tooltip.style.position = 'absolute';
        tooltip.style.minWidth = width + 'px';
        tooltip.style.minHeight = height + 'px';
        tooltip.style.paddingTop = padding_top + 'px';
        //tooltip.style.display = 'block';
        tooltip.style[vertical_pos] = top + 'px';
        tooltip.style[horizontal_pos] = left + 'px';
        
        tooltip.classList.add("position-" + vertical_pos + '-' + horizontal_pos);
    }

    selectElement("#app_cart_added_container.app_cart_sticky", el => el.classList.add('open'));

    setTimeout(function() {
        tooltip.classList.add('open');
    }, 10);

    if (!window.DS24_TOOLTIP_SHOWN_BY_CLICK) {
        let hideTooltipTimeout: any;
        tooltip.addEventListener('mouseover', function() {
            if (hideTooltipTimeout) {
                clearTimeout(hideTooltipTimeout);
                hideTooltipTimeout = null;
                return;
            }
            tooltip.classList.add('open');
        });
        tooltip.addEventListener('mouseout', function() {
            if (!window.DS24_HOVER_DISABLED && !window.DS24_TOOLTIP_SHOWN_BY_CLICK) {
                hideTooltipTimeout = setTimeout(() => {
                    tooltip.classList.remove('open');
                    hideTooltipTimeout = null;
                }, 50);
            }
        });
    }

    return div_id;

}